import React from 'react'

const SVGArrow = ({
  direction = "down", 
  variant = 1, // variant 1 is the black button arrow; variant 2 is the white arrow that appears beside the form page number.
  className
}) => {

  const directions = {
    "left": 90,
    "down": 0,
    "right": 270,
    "up": 180,
  }

  return (variant === 1 ? 
    <svg 
      className={className} 
      width="24" 
      height="25" 
      viewBox="0 0 24 25" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg" 
    >
      <path d="M13.5 2C13.5 1.17157 12.8284 0.5 12 0.5C11.1716 0.5 10.5 1.17157 10.5 2L13.5 2ZM10.9393 24.0607C11.5251 24.6464 12.4749 24.6464 13.0607 24.0607L22.6066 14.5147C23.1924 13.9289 23.1924 12.9792 22.6066 12.3934C22.0208 11.8076 21.0711 11.8076 20.4853 12.3934L12 20.8787L3.51472 12.3934C2.92893 11.8076 1.97918 11.8076 1.3934 12.3934C0.807611 12.9792 0.807611 13.9289 1.3934 14.5147L10.9393 24.0607ZM10.5 2L10.5 23L13.5 23L13.5 2L10.5 2Z" transform={`rotate(${directions[direction]})`} transform-origin="center"/>
    </svg> 
    : variant === 2 && <svg className={className} width="21" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.29094 21.2072C7.68146 21.5978 8.31463 21.5978 8.70515 21.2072L15.0691 14.8433C15.4596 14.4527 15.4596 13.8196 15.0691 13.4291C14.6786 13.0385 14.0454 13.0385 13.6549 13.4291L7.99805 19.0859L2.34119 13.4291C1.95067 13.0385 1.3175 13.0385 0.92698 13.4291C0.536456 13.8196 0.536456 14.4527 0.92698 14.8433L7.29094 21.2072ZM6.99805 0.500122L6.99805 20.5001H8.99805L8.99805 0.500122L6.99805 0.500122Z" transform={`rotate(${directions[direction]})`} transform-origin="center"/>
    </svg>
    
  )
}

export default SVGArrow;
